import './scss/bootstrap.scss';
import './scss/fontawesome.scss';
import './scss/spinao.scss';

if(window.Event === undefined) {
    console.log('initEvent');
    window.Event = function(event, params) {
          var evt, origPrevent;
          params = params || {
              bubbles: false,
              cancelable: false,
              detail: undefined
            };

          evt = document.createEvent("CustomEvent");
          evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
          evt.composed = params.composed;

          origPrevent = evt.preventDefault;
          evt.preventDefault = function () {
            origPrevent.call(this);
            try {
              Object.defineProperty(this, 'defaultPrevented', {
                get: function () {
                  return true;
                }
              });
            } catch(e) {
              this.defaultPrevented = true;
            }
          };
          return evt;
    };
}

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import "../assets-base/assets-src/js/bootstrap/Carousel";
import "../assets-base/assets-src/js/bootstrap/Dropdown";
import "../assets-base/assets-src/js/bootstrap/Button";
import "../assets-base/assets-src/js/bootstrap/Collapse";
import "../assets-base/assets-src/js/bootstrap/Tab";
import BSCustomFileInput from '../assets-base/assets-src/js/bootstrap/CustomFileUpload/index';
import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
import * as BackToTop from '../assets-base/assets-src/js/Spinao/BackToTop';
import * as EUCookie from '../assets-base/assets-src/js/Spinao/EUCookie';
import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as GoogleReCaptcha from '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
import * as Offside from '../assets-base/assets-src/js/offside';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as EndlessList from '../assets-base/assets-src/js/Spinao/EndlessList';
import * as FilterForm from '../assets-base/assets-src/js/Spinao/FilterForm';
import * as Range from '../assets-base/assets-src/js/Spinao/FilterRange';
import * as DatePicker from "../assets-base/assets-src/js/Spinao/DatePicker";
import * as GroupFilter from "../assets-base/assets-src/js/Spinao/GroupFilter";
import * as NetteAjaxLink from '../assets-base/assets-src/js/Spinao/NetteAjaxLink';
import * as PlusMinusBtn from '../assets-base/assets-src/js/Spinao/PlusMinusBtn';
import * as RadioLikeCheckboxes from '../assets-base/assets-src/js/Spinao/RadioLikeCheckboxes';
import * as AnimatedAnchors from '../assets-base/assets-src/js/Spinao/AnimatedAnchors';
import * as CheckboxCombinations from '../assets-base/assets-src/js/Spinao/CheckboxCombinations';
import * as FormPersister from '../assets-base/assets-src/js/Spinao/FormPersister';
import * as AttributeSetter from '../assets-base/assets-src/js/Spinao/AttributeSetter';
import "../assets-base/assets-src/js/Spinao/CookieConsent";
import "../assets-base/assets-src/js/Spinao/Basket";
import "../assets-base/assets-src/js/Spinao/CarouselOnSlid";
import * as Ares from "../assets-base/assets-src/js/Spinao/Ares";

window.recaptchaEnterprise = true;

window.openGallery = function (items, active) {
    document.dispatchEvent(new CustomEvent(
        'openGallery', {
            detail: {
                items: items,
                active: active,
            }
        }
    ));
};

document.addEventListener("DOMContentLoaded", function() {

    CheckboxCombinations.initialize();

    Offside.initialize('navbarCollapse', {
        buttonsSelector: '.js-offcanvas-trigger'
    });

    Lightgallery.applyTo('[data-lightgallery="area"]', {
        selector:'[data-lightgallery="image"]',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    FormPersister.initialize();

    PlusMinusBtn.initialize();

    StickyTopMenu.initialize();

    RadioLikeCheckboxes.initialize();

    UnifyHeight.applyTo('.js-unify-height');
    UnifyHeight.applyDataAttribute();

    BackToTop.applyTo('backtotop_js');

    EUCookie.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');
    NetteAjaxLink.applyTo('[data-ajax="link"]');

    FilterForm.initialize();
    EndlessList.applyTo('[data-endless-list]');

    BSCustomFileInput.init();

    Range.initialize();

    GoogleMaps.initialize();
    GoogleReCaptcha.initialize();
    DatePicker.initialize();

    GroupFilter.initialize();

    AnimatedAnchors.run();
    AttributeSetter.run();
    Ares.run();
});
